<template>
  <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="">
            </div>
            <div class="title-info">
              <span>黑名单管理</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-header">
      <div class="num-list">
        <div class="num-item" v-for="item in numList" :key="item.name" :style="{color:item.color}">
          <div>
            <img :src="item.img" alt="">
            <span>{{ item.name }}</span>
          </div>
          <p :style="{color:item.color}">{{item.num }}</p>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="黑名单" name="1"></el-tab-pane>
<!--        <el-tab-pane label="白名单" name="2"></el-tab-pane>-->
        <div class="add-container" @click="handleAddCase">
          <img src="@/assets/add.png" alt="">
          新增记录
        </div>
      </el-tabs>
      <myTableSearch labelNameWidth="80px" :isOperate="true" :operateWidth="120" :formData="formData"
                     :tableLabel="tableLabel" :isSelection="false"
                     :queryFn="queryFn" :queryParams="queryParams" @recombinationData="recombinationData" @successQuery="successQuery" :searchColLg="6"
                     ref="tableRef" dataRow="rows" style="overflow-y: hidden">
        <template #list="scope">
          {{ selectDictLabel(userTypeList,scope.row.list) }}
        </template>
        <template #operate="scope">
          <el-button @click="handleEditCase(scope.row)" size="small" type="text">编辑</el-button>
          <el-button @click="handleDeleteCase(scope.row)" size="small" type="text">删除</el-button>
        </template>
      </myTableSearch>
      <blackAndWhiteAdd :isDialog="isAddCaseDialog" v-if="isAddCaseDialog" :rowData="editData" :type="type" @handleClose="handleAddCaseDialogClose"></blackAndWhiteAdd>
    </div>
  </div>
</template>

<script>
import {getBlackList,deleteBlackList} from '@/api/recognition/blackList'
import arrowLeftIcon from '@/assets/pages/appointment/arrow-l.png'
import arrowRightIcon from '@/assets/pages/appointment/arrow-r.png'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import deleteIcon from '@/assets/pages/appointment/delete.png'
import addIcon from '@/assets/pages/appointment/add.png'
import blackAndWhiteAdd from '@/views/pages/recognition/blackAndWhite/components/add.vue'
import blackIcon from "@/assets/black-icon.png"
import {getListByDictType} from "@/api/sys/dictData";
export default {
  components: {
    blackAndWhiteAdd
  },
  data() {
    return {
      arrowLeftIcon,
      arrowRightIcon,
      refreshIcon,
      deleteIcon,
      addIcon,
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50]
      },
      activeName:'1',
      isSubscribeDialog: false,//新增/编辑预约弹窗
      isEdit: false,//是否为编辑模式
      editData: {},//编辑时的数据
      numList: [
        {
          name:'黑名单单位/个人',
          img:blackIcon,
          num:0,
          color:'rgb(41, 125, 238)'
        },
        // {
        //   name:'白名单单位/个人',
        //   img:whiteIcon,
        //   num:0,
        //   color: 'rgb(32, 201, 128)'
        // }
      ],
      formData: [
        {
          label: '名称',
          type: 'input',
          key: 'name',
          colLg: 8,
          placeholder: '请输入单位名称/个人姓名'
        },
      ],
      tableLabel: [
        {
          prop: 'list',
          label: '类型',
          width: 120
        },
        {
          prop: 'name',
          label: '单位名称/个人姓名',
          width: 240
        },
        {
          prop: 'identification',
          label: '身份证号/统一社会信用代码',
          width: 200
        },
        {
          prop: 'cause',
          label: '列入原因',
        },
        {
          prop: 'createTime',
          label: '列入日期',
          width: 160
        },
      ],
      isAddCaseDialog: false,
      type:1,
      userTypeList:[]
    }
  },
  created() {
    this.loadDict()
  },
  methods: {
    // 获取列表数据
    queryFn(queryParams) {
      return getBlackList(queryParams)
    },
    // 刷新列表
    handleRefresh() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 查看详情
    handleView(row) {

    },
    recombinationData(params, callback){
      callback(params)
     },
    handleAddCase() {
      this.isAddCaseDialog = true
      this.type = 1
    },
    handleClick(){
      this.handleRefresh()
    },
    // 删除案件
    handleDeleteCase(row) {
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBlackList({id: row.id}).then(res => {
          if (res && res?.code === 200) {
            this.$message.success('删除成功！')
            this.handleRefresh()
          }
        })
      })
    },
    // 更新总数
    successQuery(e) {
      this.numList[0].num = e.total
    },
    handleAddCaseDialogClose() {
      this.isAddCaseDialog = false;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 编辑案件
    handleEditCase(row) {
      this.type=2
      this.isAddCaseDialog = true
      this.editData = row
    },
    handleAddCaseSubmit() {

    },
    loadDict() {
      getListByDictType('black_white_user_type').then(res => {
        this.userTypeList = res.data
      })
    }
  },
}
</script>


<style lang="scss" scoped>
/deep/.el-tabs__content {
  height: 32px;
  top: -48px;
}
.add-container{
  position: absolute;
  right: 0px;
  width: 112px;
  height: 32px;
  background-image: url("~@/assets/add-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img{
    width:20px;
    height: 20px;
    margin-right: 4px;
  }
  color: rgba(255, 255, 255, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.num-list{
  display: flex;
  gap: 16px;
  margin-bottom: 18px;
  .num-item{
    flex: 1;
    height: 96px;
    border-radius: 4px;
    border: 1px solid rgba(234, 231, 231, 1);
    background: rgba(247, 247, 247, 1);
    padding: 24px;
    display: flex;
    align-items: center;
    div{
      display: flex;
      align-items: center;
      img{
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 16px;
      }
      color: rgba(42, 51, 71, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 500;
      font-size: 16px;

    }
    p{
      flex: 1;
      text-align: right;
      color: rgba(41, 125, 238, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 500;
      font-size: 30px;
    }
  }
}
.content-header{
  display: flex;
  flex-flow: column;
  .myTableSearch{
    flex: 1;
    margin-top: -20px;
  }
}
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  /deep/.el-tabs__item{
    width: 106px;
    height: 32px;
    border-radius:  16px 16px 0px 0px;
    clip-path: polygon(
            8% 0,    /* 左上起点 */
            92% 0,   /* 右上起点 */
            100% 100%, /* 右下终点 */
            0% 100%  /* 左下终点 */
    );
    background: rgba(237, 240, 242, 1);
    text-align: center;
    line-height: 32px;
    padding: 0px;
    &:last-child{
      margin-left: 8px;
    }
  }
  /deep/.el-tabs__item.is-active{
    background: rgba(41, 125, 238, 1);
    color: rgba(255, 255, 255, 1);
  }
  /deep/.el-tabs__active-bar{
    display: none;
  }
  &-select {
    height: 50px;

    .select-title {
      height: 46px;
      background: url('~@/assets/appraisal/selectBg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;

      .title-img {
        width: 18px;
        height: 18px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title-info {
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }

    .select-serch {
      margin-top: 12px;
      display: flex;
      align-items: center;
      gap: 8px;

      .serch-hint {
        color: var(--vt-c-black-mute-soft);
        font-size: 14px;
        font-weight: 400;
      }

      .serch-info {
        height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;

        .info-item {
          width: 120px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          background: var(--vt-c-blue-mute);
          color: var(--vt-c-blue);
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          &.active {
            background: var(--vt-c-blue);
            color: var(--vt-c-white);
          }

          &:active:not(.active) {
            transform: scale(0.98);
          }
        }
      }
    }
  }

  &-header {
    margin-top: 16px;
    padding: 0 24px;
    /deep/.myTableSearch {
      padding: 0px  16px 24px;
    }
  }
}

.link-text {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .add-icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #FCFCFCFF;
    }

    .list-title {
      font-size: 14px;
      font-weight: 400;
      color: var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/ .el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}
.content-header{
  flex: 1;
  display: flex;
  flex-flow: column;
  overflow-y: hidden;
}
</style>